// Utilities
import brandUtil from '../../utility/brandUtil'
import envUtil from '../../utility/environmentUtils'
import isEmpty from '../../utility/isEmpty'
import { AppBrands, NavigationBrands, ServiceBrands } from '../../constants'

export default {
  userBrandCount (state) {
    return isEmpty(state.brands) ? 0 : Object.keys(state.brands).length
  },

  isCash1User () {
    return process.env.VUE_APP_AppBrand === AppBrands.c1l
  },

  isCaliforniaCheckCashUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.ccc
  },

  isCheckIntoCashUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.cic
  },

  isCheckSmartUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.chs
  },

  isCommunityChoiceUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.ccf
  },

  isEasyMoneyUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.esm
  },

  isTitleBucksUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.tbs
  },

  isInstaLoanUser (state, getters) {
    return getters.userBrandCount > 0 && Object.keys(state.brands).includes(ServiceBrands.InstaLoan)
  },

  isTitleMaxUser (state, getters) {
    return getters.userBrandCount > 0 && Object.keys(state.brands).includes(ServiceBrands.TitleMax)
  },

  isCash1Available (state, getters) {
    return getters.isCash1User ? (state.brands[ServiceBrands.Cash1Loans].availableProviders || []).length > 0 : false
  },

  isCaliforniaCheckCashAvailable (state, getters) {
    return getters.isCaliforniaCheckCashUser ? (state.brands[ServiceBrands.CaliforniaCheckCash].availableProviders || []).length > 0 : false
  },

  isCheckIntoCashAvailable (state, getters) {
    return getters.isCheckIntoCashUser ? (state.brands[ServiceBrands.CheckIntoCash].availableProviders || []).length > 0 : false
  },

  isCheckSmartAvailable (state, getters) {
    return getters.isCheckSmartUser ? (state.brands[ServiceBrands.CheckSmart].availableProviders || []).length > 0 : false
  },

  isCommunityChoiceAvailable (state, getters) {
    return getters.isCommunityChoiceUser ? (state.brands[ServiceBrands.CommunityChoice].availableProviders || []).length > 0 : false
  },

  isEasyMoneyAvailable (state, getters) {
    return getters.isEasyMoneyUser ? (state.brands[ServiceBrands.EasyMoney].availableProviders || []).length > 0 : false
  },

  isInstaLoanAvailable (state, getters) {
    return getters.isInstaLoanUser ? (state.brands[ServiceBrands.InstaLoan].availableProviders || []).length > 0 : false
  },

  isTitleBucksAvailable (state, getters) {
    return getters.isTitleBucksUser ? (state.brands[ServiceBrands.TitleBucks].availableProviders || []).length > 0 : false
  },

  isTitleMaxAvailable (state, getters) {
    return getters.isTitleMaxUser ? (state.brands[ServiceBrands.TitleMax].availableProviders || []).length > 0 : false
  },

  hasAvailableProviders (state) {
    for (const brand of Object.keys(state.brands)) {
      if (!isEmpty(state.brands[brand].availableProviders)) {
        return true
      }
    }
    return false
  },

  isTitleMaxLimited (state, getters) {
    return getters.isTitleMaxUser ? (state.brands[ServiceBrands.TitleMax].providers || []).length > (state.brands[ServiceBrands.TitleMax].availableProviders || []).length : false
  },

  /**
   * Returns the current brand to use for navigation based on customers linked and loans associated. Defaults to using app brand.
   * @returns {String} The navigation brand.
   */
  navigationBrand (state, getters) {
    if (getters.isCash1User) {
      return NavigationBrands.Cash1Loans
    } else if (getters.isCaliforniaCheckCashUser) {
      return NavigationBrands.CaliforniaCheckCash
    } else if (getters.isCheckSmartUser) {
      return NavigationBrands.CheckSmart
    } else if (getters.isCheckIntoCashUser) {
      return NavigationBrands.CheckIntoCash
    } else if (getters.isEasyMoneyUser) {
      return NavigationBrands.EasyMoney
    } else if (getters.isCommunityChoiceUser) {
      return NavigationBrands.CommunityChoice
    } else if (getters.isTitleBucksUser) {
      return NavigationBrands.TitleBucks
    } else if (!getters.isTitleMaxUser && getters.isInstaLoanUser) {
      return NavigationBrands.InstaLoan
    } else if (getters.isTitleMaxUser) {
      return NavigationBrands.TitleMax
    } else {
      return brandUtil.getNavigationBrandByAppBrand(envUtil.appBrand)
    }
  },

  /**
   * Returns the current brand's external privacy policy URL.
   * @returns {String} The current brand's external privacy policy URL.
   */
  brandedPrivacyPolicyUrl (state, getters) {
    if (getters.isCash1User) {
      return state.c1lPrivacyPolicyUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return state.cccPrivacyPolicyUrl
    }

    if (getters.isCheckSmartUser) {
      return state.chsPrivacyPolicyUrl
    }

    if (getters.isCheckIntoCashUser) {
      return state.cicPrivacyPolicyUrl
    }

    if (getters.isCommunityChoiceUser) {
      return state.ccfPrivacyPolicyUrl
    }

    if (getters.isEasyMoneyUser) {
      return state.esmPrivacyPolicyUrl
    }

    if (getters.isTitleBucksUser) {
      return state.tbsPrivacyPolicyUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return state.inlPrivacyPolicyUrl
    }

    return state.tmxPrivacyPolicyUrl
  },

  /**
   * Returns the current brand's external terms and conditions URL.
   * @returns {String} The current brand's external terms and conditions URL.
   */
  brandedTermsConditionsUrl (state, getters) {
    if (getters.isCash1User) {
      return state.c1lTermsConditionsUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return state.cccTermsConditionsUrl
    }

    if (getters.isCheckSmartUser) {
      return state.chsTermsConditionsUrl
    }

    if (getters.isCheckIntoCashUser) {
      return state.cicTermsConditionsUrl
    }

    if (getters.isCommunityChoiceUser) {
      return state.ccfTermsConditionsUrl
    }

    if (getters.isEasyMoneyUser) {
      return state.esmTermsConditionsUrl
    }

    if (getters.isTitleBucksUser) {
      return state.tbsTermsConditionsUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return state.inlTermsConditionsUrl
    }

    return state.tmxTermsConditionsUrl
  },

  /**
   * Returns the current brand's store locator URL.
   * @returns {String} The current brand's store locator URL.
   */
  brandedStoreLocatorUrl (state, getters) {
    if (getters.isCash1User) {
      return state.c1lStoreLocatorSiteUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return state.cccStoreLocatorSiteUrl
    }

    if (getters.isCheckSmartUser) {
      return state.chsStoreLocatorSiteUrl
    }

    if (getters.isCheckIntoCashUser) {
      return state.cicStoreLocatorSiteUrl
    }

    if (getters.isCommunityChoiceUser) {
      return state.ccfStoreLocatorSiteUrl
    }

    if (getters.isEasyMoneyUser) {
      return state.esmStoreLocatorSiteUrl
    }

    if (getters.isTitleBucksUser) {
      return state.tbsStoreLocatorSiteUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return state.inlStoreLocatorSiteUrl
    }

    return state.tmxStoreLocatorSiteUrl
  },

  /**
   * Returns the current brand's auto dialer URL.
   * @returns {String} The current brand's auto dialer URL.
   */
  brandedAutoDailerUrl (state, getters) {
    if (getters.isCash1User) {
      return state.c1lAutoDailerUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return state.cccAutoDailerUrl
    }

    if (getters.isCheckSmartUser) {
      return state.chsAutoDailerUrl
    }

    if (getters.isCheckIntoCashUser) {
      return state.cicAutoDailerUrl
    }

    if (getters.isCommunityChoiceUser) {
      return state.ccfAutoDailerUrl
    }

    if (getters.isEasyMoneyUser) {
      return state.esmAutoDailerUrl
    }

    if (getters.isTitleBucksUser) {
      return state.tbsAutoDailerUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return state.inlAutoDailerUrl
    }

    return state.tmxAutoDailerUrl
  },

  /**
   * Returns the current brand's econsent URL.
   * @returns {String} The current brand's econsent URL.
   */
  brandedEconsent (state, getters) {
    if (getters.isCash1User) {
      return state.c1lEconsentUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return state.cccEconsentUrl
    }

    if (getters.isCheckSmartUser) {
      return state.chsEconsentUrl
    }

    if (getters.isCheckIntoCashUser) {
      return state.cicEconsentUrl
    }

    if (getters.isCommunityChoiceUser) {
      return state.ccfEconsentUrl
    }

    if (getters.isEasyMoneyUser) {
      return state.esmEconsentUrl
    }

    if (getters.isTitleBucksUser) {
      return state.tbsEconsentUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return state.inlEconsentUrl
    }

    return state.tmxEconsentUrl
  }
}
